import { render, staticRenderFns } from "./ViewMessagePageContainer.vue?vue&type=template&id=3a982efa&"
import script from "./ViewMessagePageContainer.vue?vue&type=script&lang=js&"
export * from "./ViewMessagePageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports